import React from 'react';
import { Shield } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 bg-white" data-id="element-56">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-57">
        <div className="max-w-3xl mx-auto bg-white border-4 border-oliva rounded-2xl p-8 sm:p-12 text-center shadow-lg relative" data-id="element-58">
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-4 rounded-full border-4 border-oliva" data-id="element-59">
            <Shield className="w-12 h-12 text-oliva" data-id="element-60" />
          </div>

          <h3 className="text-2xl sm:text-3xl font-heading font-bold text-marron mt-8 mb-6" data-id="element-61">
            Garantía de 7 Días — "Volvé a Ser Vos" o te Devolvemos Todo
          </h3>

          <div className="text-lg text-marron-light leading-relaxed space-y-4" data-id="element-62">
            <p data-id="element-63">
              Tenés 7 días para probar las recetas, explorar cada módulo y
              aplicar el plan.
            </p>
            <p data-id="element-64">
              Si no sentís una diferencia real en tu energía, tu sueño, tu
              digestión o tu nivel de dolor — te devolvemos cada peso, sin
              preguntas, sin vueltas, sin formularios complicados.
            </p>
            <p className="font-bold text-marron pt-4" data-id="element-65">
              No es solo una garantía. Es nuestra forma de decirte: confiamos
              completamente en lo que hay adentro de este manual digital.
            </p>
          </div>
        </div>
      </div>
    </section>;
}